export default "__VITE_ASSET__BOT9EVpK__"